/* eslint-disable react/jsx-no-literals */
/* eslint-disable no-tabs */
import { FC } from 'react';

import { MpParagraph } from 'shared/ui/MpParagraph';
import { MpText } from 'shared/ui/MpText';
import { ImageStyled, OlStyled } from './BrandPanelInstrutions.styles';

export const BrandPanelInstructions: FC = () => (
	<>
		<MpParagraph>Открыть панель можно на компьютере или телевизоре.</MpParagraph>
		<MpText weight='bold' style={{ marginBottom: `8px` }}>
			На компьютере
		</MpText>
		<OlStyled>
			<li>
				{`Для открытия на компьютере перейдите по ссылке `}
				<a href='https://realtime.dodobrands.io/?source=marketplace' target='_blank' rel='noreferrer'>
					https://realtime.dodobrands.io/?source=marketplace
				</a>
				<ImageStyled src='https://cdn.dodostatic.net/static/marketplace/digitalbp/instructions1' />
			</li>
		</OlStyled>
		<MpText weight='bold' style={{ marginBottom: `8px` }}>
			На телевизоре или ТВ-панели
		</MpText>
		<OlStyled>
			<li>Откройте встроенный браузер телевизора</li>
			<li>
				{`Введите веб-адрес `}
				<a href='https://realtime.dodobrands.io/?source=marketplace' target='_blank' rel='noreferrer'>
					vdo.do/digitalbp
				</a>
				<ImageStyled src='https://cdn.dodostatic.net/static/marketplace/digitalbp/slider4' />
			</li>
		</OlStyled>
	</>
);
